<template>
    <div class="row">
        <div class="col-lg-12">
            <iq-card>
                <template v-slot:headerTitle>
                    <h4 class="card-title">Gizlilik Ayarları</h4>
                </template>
                <template v-slot:body>
                    <div class="acc-privacy">
                        <div class="data-privacy">
                            <h4 class="mb-2">Hesap Gizliliği</h4>
                            <div class="form-check form-check-inline">
                            <input type="checkbox" class="form-check-input" id="acc-private">
                            <label class="form-check-label privacy-status mb-2" for="acc-private">Private Account</label>
                            </div>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book</p>
                        </div>
                        <hr>
                        <div class="data-privacy">
                            <h4 class="mb-2">Durum</h4>
                            <div class="form-check form-check-inline">
                            <input type="checkbox" class="form-check-input" id="activety" checked="">
                            <label class="form-check-label privacy-status mb-2" for="activety">Durumu Göster</label>
                            </div>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tempus mauris a nibh sodales, nec congue ipsum auctor. Suspendisse facilisis tincidunt elit, eu egestas nisl semper eget. Nulla non aliquam metus. Etiam interdum ornare sodales. Cras consectetur id metus</p>
                        </div>
                        <hr>
                        <div class="data-privacy">
                            <h4 class="mb-2">Hikaye Paylaşımı</h4>
                            <div class="form-check form-check-inline">
                            <input type="checkbox" class="form-check-input" id="story" checked="">
                            <label class="form-check-label privacy-status mb-2" for="story">Paylaş</label>
                            </div>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tempus mauris a nibh sodales, nec congue ipsum auctor. Suspendisse facilisis tincidunt elit, eu egestas nisl semper eget. Nulla non aliquam metus. Etiam interdum ornare sodales. Cras consectetur id metus</p>
                        </div>
                        <hr>
                        <div class="data-privacy">
                            <h4 class="mb-2"> Fotoğrafın </h4>
                            <div class="custom-control custom-radio">
                            <input type="radio" id="automatically" name="customRadio0" class="form-check-input" checked="" >
                            <label class="form-check-label" for="automatically">  Otomatik Olarak Ekle</label>
                            </div>
                            <div class="custom-control custom-radio mb-2">
                            <input type="radio" id="manualy" name="customRadio0" class="form-check-input">
                            <label class="form-check-label" for="manualy">Ekle</label>
                            </div>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tempus mauris a nibh sodales, nec congue ipsum auctor. Suspendisse facilisis tincidunt elit, eu egestas nisl semper eget. Nulla non aliquam metus. Etiam interdum ornare sodales. Cras consectetur id metus</p>
                        </div>
                        <hr>
                        <div class="data-privacy">
                            <h4 class="mb-2"> Profil </h4>
                            <div class="custom-control custom-radio">
                            <input type="radio" id="public" name="customRadio1" class="form-check-input" checked="">
                            <label class="form-check-label" for="public"> Public </label>
                            </div>
                            <div class="custom-control custom-radio">
                            <input type="radio" id="friend" name="customRadio1" class="form-check-input">
                            <label class="form-check-label" for="friend"> Arkadaşlar </label>
                            </div>
                            <div class="custom-control custom-radio">
                            <input type="radio" id="spfriend" name="customRadio1" class="form-check-input">
                            <label class="form-check-label" for="spfriend"> Özel Arkadaşlar</label>
                            </div>
                            <div class="custom-control custom-radio mb-2">
                            <input type="radio" id="onlyme" name="customRadio1" class="form-check-input">
                            <label class="form-check-label" for="onlyme"> Yalnızca Ben </label>
                            </div>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tempus mauris a nibh sodales, nec congue ipsum auctor. Suspendisse facilisis tincidunt elit, eu egestas nisl semper eget. Nulla non aliquam metus. Etiam interdum ornare sodales. Cras consectetur id metus</p>
                        </div>
                        <hr>
                        <div class="data-privacy">
                            <h4 class="mb-2"> Giriş Bildirimleri</h4>
                            <div class="custom-control custom-radio">
                            <input type="radio" id="enable" name="customRadio2" class="form-check-input">
                            <label class="form-check-label" for="enable"> Aktif </label>
                            </div>
                            <div class="custom-control custom-radio mb-2">
                            <input type="radio" id="disable" name="customRadio2" class="form-check-input" checked="">
                            <label class="form-check-label" for="disable"> İnaktif </label>
                            </div>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tempus mauris a nibh sodales, nec congue ipsum auctor. Suspendisse facilisis tincidunt elit, eu egestas nisl semper eget. Nulla non aliquam metus. Etiam interdum ornare sodales. Cras consectetur id metus</p>
                        </div>
                        <hr>
                        <div class="data-privacy">
                            <h4 class="mb-2">Gizlilik Yardımı</h4>
                            <a href="#"><i class="ri-customer-service-2-line me-2"></i>Support</a>
                        </div>
                    </div>
                </template>
            </iq-card>
        </div>
    </div>
</template>
<script>
export default {
  name: 'PrivacySetting'
}
</script>
